module.exports = __webpack_public_path__ + "static/media/25.94ba4b08.png";